import { ShapeOptions } from '@mui/system/createTheme/shape';

const shape: ShapeOptions = {
    borderRadius: 8,
};

export default shape;
